<template>
    <div class="cf-form-wrapper">
        <form class="cf-form">
            <textarea
                v-model="message"
                ref="message"
                name="message"
                id="message"
                cols="30"
                rows="2"
                :maxLength="messageCounter"
                :placeholder="$t('pages.comments.commentFormPlaceholder')"
                @input="autoResizeHeight"
                @focus="error = null"
            ></textarea>
            <div class="cf-message-counter">
                {{ messageLength }} / {{ messageCounter }}
            </div>
            <comments-button
                :disabled="!message"
                icon="send"
                icon-size="24"
                @click="createComment"
            />
        </form>
        <to-auth-suggestion
            v-if="showLoginMassage"
        />
        <small
            v-if="error && user"
            class="cf-red-color"
        >
            {{ error }}
        </small>
        <comments-preloader
            v-if="loading"
        />
    </div>

</template>

<script>
import CommentsIcon from './CommentsIcon'
import CommentsButton from "./CommentsButton";
import CommentsPreloader from "./CommentsPreloader";
import commentsBasePropsMixin from "./mixins/commentsBasePropsMixin";
import ToAuthSuggestion from '@/components/UIComponents/ToAuthSuggestion.vue'

export default {
    name: 'CommentsForm',
    mixins: [commentsBasePropsMixin],
    components: { ToAuthSuggestion, CommentsPreloader, CommentsButton, CommentsIcon},
    props: {
        parentId: {
            type: String,
            default: null
        }
    },
    computed: {
        messageLength() {
            return typeof this.message === 'string'
                ? this.message.length
                : 0
        },
        loginPath() {
            const redirectTo = this.$route.path
            return this.localePath('/login?redirectTo='+redirectTo)
        }
    },
    data() {
        return {
            loading: false,
            message: null,
            error: null,
            showLoginMassage: false
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.message.setAttribute('style', `height: ${this.$refs.message.scrollHeight}px`);
        });
    },
    methods: {
        autoResizeHeight(event) {
            event.target.style.height = 'auto';
            event.target.style.height = `${event.target.scrollHeight}px`;
        },
        async createComment() {

            if(!this.user) {
                this.showLoginMassage = true
                return
            }

            this.loading = true
            this.error = null

            const params = {
                message: this.message,
                postId: this.postId,
                user: this.user,
                tags: this.tags,
                options: this.options,
                parentId: this.parentId,
                status: this.moderable
                    ? this.statusModeration
                    : this.statusActive
            }

            try {
                const response = await this.$api.comments.createComment(params)

                if(response.data.success === 0) {
                    this.error = response.data.message
                    this.$emit('error', this.error)
                } else {
                    this.message = null
                    this.$emit('success', response.data.data)
                }

            } catch (error) {
                this.$emit('error', error.response.data.message)
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
